import { MoreVert } from '@mui/icons-material';
import { Button, Menu, MenuItem, Theme, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';

interface CommentActionProps {
  enableEditComment?: boolean;
  enableDeleteComment?: boolean;
  onEditComment?: () => void;
  onDeleteComment?: () => void;
  locale?: Record<string, any>;
}

const CommentAction = (props: CommentActionProps) => {
  const { enableEditComment, enableDeleteComment, onEditComment, onDeleteComment, locale } = props;

  const isSmDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return isSmDown ? (
    <>
      <Button className="buttonLink attachment" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreVert sx={{ width: 20 }} />
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} disableScrollLock >
        {enableEditComment && <MenuItem onClick={onEditComment}>{locale?.txtEdit}</MenuItem>}
        {enableDeleteComment && <MenuItem onClick={onDeleteComment}>{locale?.txtDelete}</MenuItem>}
      </Menu>
    </>
  ) : (
    <>
      {enableEditComment && (
        <Button className="buttonLink" onClick={onEditComment} id='btn-edit-comment'>
          {locale?.txtEdit}
        </Button>
      )}
      {enableDeleteComment && (
        <Button className="buttonLink" onClick={onDeleteComment} id='btn-delete-comment'>
          {locale?.txtDelete}
        </Button>
      )}
    </>
  );
};

export default CommentAction;
